import * as _ from 'lodash';
import moment from 'moment';

import Locator from '../../../../../shared/Locator';
import titleCase from '../../../../../shared/utils/titleCase';
import { RevisionSource } from '../../../../../typings/enums';
import utils from '../../../../utils';
import type { Revision } from '../../../../types';

/**
 * Get the revision message to display in the dropdown
 */
export function getRevisionMessage({
  revision,
  isSelected,
  shouldShowAnalyzedLabel,
}: {
  revision?: Revision;
  isSelected: boolean;
  shouldShowAnalyzedLabel: boolean;
}) {
  if (!revision) {
    return '...';
  }
  const trimLength = isSelected ? 200 : 45;
  let message: string;

  if (revision.message && !_.isEmpty(revision.message)) {
    message = revision.message;
    // The format is important to ensure firefox displays the date correctly
    const timestamp = moment(revision.revision_timestamp, 'YYYY-MM-DD HH:mm:ss.SSS ZZ');
    const shouldShowAnalyzed = shouldShowAnalyzedLabel && timestamp.isValid();
    const dateToFormat = timestamp.toDate();
    //  Check if the date is valid by verifying the timestamp is finite.
    //  This helps prevent RangeErrors in the event of an invalid date.
    if (shouldShowAnalyzed && Number.isFinite(dateToFormat.getTime())) {
      const text = new Intl.DateTimeFormat('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        timeZoneName: 'short',
      }).format(dateToFormat);
      message = `Analyzed: ${text}`;
    }
  } else {
    message = Locator.parse(revision.locator).revision || '...';
  }

  return utils.trimString(message, trimLength);
}

/**
 * Get the source text to display in the badge
 */
export function getSourceText(source?: RevisionSource): string | null {
  if (!source) {
    return null;
  }

  switch (source) {
    case RevisionSource.GitHub:
      return 'GitHub';
    case RevisionSource.CLI:
      return 'CLI';
    case RevisionSource.SBOM:
      return 'SBOM';
    default:
      return titleCase(source);
  }
}
